export default function FeaturesSection() {
  const features = [
    {
      icon: "ri-wallet-3-line",
      title: "380₽/час на руки",
      desc: "Фиксированная почасовая ставка. Никаких процентов и скрытых вычетов. Выплаты 2 раза в месяц на карту.",
    },
    {
      icon: "ri-book-read-line",
      title: "Оплачиваемое обучение",
      desc: "Даже во время обучения вы получаете деньги. Полный курс с наставником доведёт вас до реальных смен за неделю.",
    },
    {
      icon: "ri-user-heart-line",
      title: "Личный наставник",
      desc: "За каждым новым оператором закрепляется наставник. Он помогает с первыми чатами, подсказывает и поддерживает 24/7.",
    },
    {
      icon: "ri-group-line",
      title: "Дружный коллектив",
      desc: "Общий чат операторов, где всегда можно спросить совет, поделиться опытом или просто поболтать между сменами.",
    },
    {
      icon: "ri-file-text-line",
      title: "Официальное оформление",
      desc: "Трудоустройство по договору. Самозанятые или ИП — выберите удобный для вас формат сотрудничества.",
    },
    {
      icon: "ri-bar-chart-2-line",
      title: "Рост дохода",
      desc: "Со временем ваша ставка может вырасти. Лучшие операторы получают повышенную ставку и бонусы за качество работы.",
    },
  ];

  return (
    <section id="features" className="relative py-24 lg:py-32 overflow-hidden bg-background-50">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4 bg-primary-100 text-primary-700">
            Условия
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            Что вы получите, став{" "}
            <span className="text-primary-500">оператором чата</span>
          </h2>
          <p className="text-foreground-600 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            WorkTerra обеспечивает полный цикл: от обучения до стабильных выплат. Всё, что нужно для комфортной удалённой работы.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl p-7 bg-background-50 border border-primary-100 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-lg cursor-default group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${f.icon} text-primary-500 text-4xl`} />
              </div>
              <h3 className="text-foreground-950 font-semibold text-lg mb-3">{f.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-2xl p-8 lg:p-10 flex flex-col lg:flex-row items-center justify-between gap-6 bg-primary-500">
          <div>
            <h3 className="text-background-50 font-bold text-xl lg:text-2xl mb-2">
              Готовы зарабатывать 380₽/час?
            </h3>
            <p className="text-background-100 text-sm lg:text-base">
              Свяжитесь с нами и начните обучение уже на этой неделе
            </p>
          </div>
          <a
            href="#contact"
            className="px-8 py-3 rounded-full font-semibold text-primary-500 bg-background-50 hover:bg-background-100 shadow-lg transition-colors duration-200 cursor-pointer whitespace-nowrap text-base"
          >
            Связаться с нами
          </a>
        </div>
      </div>
    </section>
  );
}